import { useState } from "react";
import { toast } from "react-toastify";
import { exportIndividuals } from "@services/individuals/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import {
  getSituationLabel,
  getGenderLabel,
  getMarkingTypeLabel,
} from "@utils/translator/individuals";
import { INDIVIDUALS_EXPORT_HEADS } from "@typings/entities/individuals/export";
import type { IndividualsFilters } from "@typings/entities/individuals/table";

export function useExportIndividuals() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (filters?: IndividualsFilters) => {
    setIsLoading(true);
    try {
      const response = await exportIndividuals(filters);

      if (!response.items?.length) {
        toast.warning("Nenhum dado de indivíduos disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        situation: getSituationLabel(item.situation),
        gender: getGenderLabel(item.gender),
        markingType: getMarkingTypeLabel(item.markingType),
        hasGPS: item.hasGPS ? "Sim" : "Não",
        lastLocationDate: formatDateTime(item.lastLocationDate || null),
        lastReleaseDate: formatDateTime(item.lastReleaseDate || null),
        lastEntranceDate: formatDateTime(item.lastEntranceDate || null),
        createdAt: formatDateTime(item.createdAt || null),
        updatedAt: formatDateTime(item.updatedAt || null),
      }));

      const formattedData = formatCSVData(
        translatedData,
        INDIVIDUALS_EXPORT_HEADS,
      );
      exportToCSV(formattedData, `relatorio_individuos_${actualDateTime()}`);
      toast.success("Relatório de indivíduos exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de indivíduos");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
